export default "__VITE_ASSET__6UEjk3uv__";